import React from 'react';
import classNames from 'classnames';

import { injectIntl } from '../../../util/reactIntl';
import { FieldCheckbox } from '../../../components';

import FilterPlain from '../FilterPlain/FilterPlain';
import FilterPopup from '../FilterPopup/FilterPopup';

import css from './BooleanFilter.module.css';

const getQueryParamName = queryParamNames => {
  return Array.isArray(queryParamNames) ? queryParamNames[0] : queryParamNames;
};

/**
 * BooleanFilter component for rendering boolean search filters (e.g. isConsignment)
 */
const BooleanFilter = props => {
  const {
    rootClassName,
    className,
    id,
    name,
    label,
    initialValues,
    contentPlacementOffset = 0,
    onSubmit,
    queryParamNames,
    intl,
    showAsPopup,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const urlParam = getQueryParamName(queryParamNames);
  const rawInitialVal = initialValues ? initialValues[urlParam] : null;
  const isChecked = rawInitialVal === 'true' || rawInitialVal === true;

  const handleSubmit = values => {
    if (!values) {
      onSubmit({ [urlParam]: null });
      return;
    }
    const val = values[name];
    const checked =
      val === true ||
      val === 'true' ||
      (Array.isArray(val) && (val.includes('true') || val.includes(true)));

    onSubmit({ [urlParam]: checked ? 'true' : null });
  };

  const labelForPlain = isChecked ? (
    <span className={css.labelPlainSelected}>{label}</span>
  ) : (
    <span className={css.labelPlain}>{label}</span>
  );

  const initialFormValues = { [name]: isChecked };

  return showAsPopup ? (
    <FilterPopup
      className={classes}
      rootClassName={rootClassName}
      popupClassName={css.popupSize}
      name={name}
      label={label}
      isSelected={isChecked}
      id={`${id}.popup`}
      showAsPopup
      labelMaxWidth={250}
      contentPlacementOffset={contentPlacementOffset}
      onSubmit={handleSubmit}
      initialValues={initialFormValues}
      keepDirtyOnReinitialize
      {...rest}
    >
      <fieldset className={css.fieldPopup}>
        <FieldCheckbox id={`${id}-checkbox-popup`} name={name} label={label} />
      </fieldset>
    </FilterPopup>
  ) : (
    <FilterPlain
      className={className}
      rootClassName={rootClassName}
      label={labelForPlain}
      isSelected={isChecked}
      id={`${id}.plain`}
      liveEdit
      onSubmit={handleSubmit}
      initialValues={initialFormValues}
      {...rest}
    >
      <fieldset className={css.fieldPlain}>
        <ul className={css.list}>
          <li className={css.item}>
            <FieldCheckbox id={`${id}-checkbox`} name={name} label={label} />
          </li>
        </ul>
      </fieldset>
    </FilterPlain>
  );
};

export default injectIntl(BooleanFilter);
